import type { InvoiceWithProject } from "@/hooks/use-invoices";
import { formatInvoiceType } from "@/lib/format";
import { effectiveInvoiceType } from "@/lib/invoice-plan";
import { invoiceKind } from "@/lib/invoice-list";

interface InvoiceTypeCellProps {
  invoice: InvoiceWithProject;
  /** Fakturanr per id, for «krediterer 32371» på kreditnotaer. */
  invoiceNoById: Map<string, number | null>;
}

/** Type med PO-merke for fakturaer laget i PowerOffice og kobling for kreditnotaer. */
export function InvoiceTypeCell({ invoice, invoiceNoById }: InvoiceTypeCellProps) {
  const kind = invoiceKind(invoice);
  if (kind === "credit_note") {
    const credited = invoice.related_invoice_id ? invoiceNoById.get(invoice.related_invoice_id) : null;
    return (
      <>
        Kreditnota
        {credited != null && <span className="block text-xs text-muted-foreground">krediterer {credited}</span>}
      </>
    );
  }
  if (kind === "poweroffice") {
    return (
      <span className="whitespace-nowrap">
        Utgående
        <span className="ml-1.5 text-[11px] border border-border rounded px-1.5 py-px text-muted-foreground">PowerOffice</span>
      </span>
    );
  }
  return <>{formatInvoiceType(effectiveInvoiceType(invoice), invoice.poweroffice_status)}</>;
}
